import {isFeatureEnabled} from '@github-ui/feature-flags'
import {jsonSafeStorage} from '@github-ui/safe-storage'
import {useMemo} from 'react'

/**
 * Hook for caching data in localStorage with feature flag control
 * @param cacheKey - The key to use for storing in localStorage
 * @returns Object with cachedValue and updateCache functions
 */
export function useLocalStorageCache<T>(cacheKey: string) {
  const safeLocalStorage = jsonSafeStorage<T>('localStorage')
  const cachingEnabled = isFeatureEnabled('copilot_agent_task_caching')

  const value: T | undefined = useMemo(() => {
    if (!cachingEnabled) return

    return safeLocalStorage.getItem(cacheKey) ?? undefined
  }, [cachingEnabled, safeLocalStorage, cacheKey])

  const setValue = (updated_value: T) => {
    if (cachingEnabled) {
      safeLocalStorage.setItem(cacheKey, updated_value)
    }
  }

  const removeItem = () => {
    if (cachingEnabled) {
      safeLocalStorage.removeItem(cacheKey)
    }
  }

  return {value, setValue, removeItem}
}
